import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-time-selector-dialog',
  template: `
    <h2 mat-dialog-title>Select Time Range</h2>
    <mat-dialog-content>
      <div style="display: flex; gap: 24px; flex-wrap: wrap;">
        <div>
          <div style="font-weight: bold; margin-bottom: 4px;">From</div>
          <div style="display: flex; gap: 8px; flex-wrap: wrap;">
            <mat-form-field appearance="fill" style="width: 80px;">
              <mat-label>Month</mat-label>
              <input matInput type="number" min="1" max="12" [(ngModel)]="fromMonth">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 80px;">
              <mat-label>Day</mat-label>
              <input matInput type="number" min="1" max="31" [(ngModel)]="fromDay">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 80px;">
              <mat-label>Hour</mat-label>
              <input matInput type="number" min="0" max="23" [(ngModel)]="fromHour">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 80px;">
              <mat-label>Minute</mat-label>
              <input matInput type="number" min="0" max="59" [(ngModel)]="fromMinute">
            </mat-form-field>
          </div>
        </div>
        <div>
          <div style="font-weight: bold; margin-bottom: 4px;">To</div>
          <div style="display: flex; gap: 8px; flex-wrap: wrap;">
            <mat-form-field appearance="fill" style="width: 80px;">
              <mat-label>Month</mat-label>
              <input matInput type="number" min="1" max="12" [(ngModel)]="toMonth">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 80px;">
              <mat-label>Day</mat-label>
              <input matInput type="number" min="1" max="31" [(ngModel)]="toDay">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 80px;">
              <mat-label>Hour</mat-label>
              <input matInput type="number" min="0" max="23" [(ngModel)]="toHour">
            </mat-form-field>
            <mat-form-field appearance="fill" style="width: 80px;">
              <mat-label>Minute</mat-label>
              <input matInput type="number" min="0" max="59" [(ngModel)]="toMinute">
            </mat-form-field>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="onConfirm()">OK</button>
    </mat-dialog-actions>
  `
})
export class TimeSelectorDialogComponent {
  fromMonth: number;
  fromDay: number;
  fromHour: number;
  fromMinute: number;
  fromSecond: number;

  toMonth: number;
  toDay: number;
  toHour: number;
  toMinute: number;
  toSecond: number;

  constructor(
    public dialogRef: MatDialogRef<TimeSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // Initialize to current time for 'to', and one hour before for 'from'
    const now = new Date();
    const from = new Date(now.getTime() - 60 * 60 * 1000); // 1 hour before
    this.fromMonth = from.getMonth() + 1;
    this.fromDay = from.getDate();
    this.fromHour = from.getHours();
    this.fromMinute = from.getMinutes();
    this.fromSecond = from.getSeconds();

    this.toMonth = now.getMonth() + 1;
    this.toDay = now.getDate();
    this.toHour = now.getHours();
    this.toMinute = now.getMinutes();
    this.toSecond = now.getSeconds();
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    // Format: MM/DD/HH/MM/SS,MM/DD/HH/MM/SS
    const pad = (n: number) => n.toString().padStart(2, '0');
    const from = `${pad(this.fromMonth)}/${pad(this.fromDay)}/${pad(this.fromHour)}/${pad(this.fromMinute)}/${pad(this.fromSecond)}`;
    const to = `${pad(this.toMonth)}/${pad(this.toDay)}/${pad(this.toHour)}/${pad(this.toMinute)}/${pad(this.toSecond)}`;

    // Convert to Date objects for comparison
    const fromDate = new Date(2000, this.fromMonth - 1, this.fromDay, this.fromHour, this.fromMinute, this.fromSecond);
    const toDate = new Date(2000, this.toMonth - 1, this.toDay, this.toHour, this.toMinute, this.toSecond);

    if (fromDate >= toDate) {
      alert('The "From" time must be before the "To" time.');
      return;
    }
    const diffMs = toDate.getTime() - fromDate.getTime();
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    if (diffDays > 2) {
      alert('The difference between "From" and "To" must not be more than 2 days.');
      return;
    }
    this.dialogRef.close(`${from},${to}`);
  }
}
